const KEY_ID_PATTERN = /^[A-Za-z0-9]{12}$/;
const ISSUER_ID_PATTERN = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export const MAX_PEM_FILE_SIZE = 64 * 1024;

export function getAppleCredentialInputErrors({ file, keyId, issuerId, messages }) {
  const errors = [];
  const normalizedKeyId = String(keyId || '').trim();
  const normalizedIssuerId = String(issuerId || '').trim();
  const fileSize = Number(file?.size);
  const validPem = file && fileSize > 0 && String(file.name || '').toLowerCase().endsWith('.pem');

  if (!file) {
    errors.push(messages.pemRequired);
  } else if (fileSize > MAX_PEM_FILE_SIZE) {
    errors.push(messages.pemTooLarge);
  } else if (!validPem) {
    errors.push(messages.pemInvalid);
  }
  if (!normalizedKeyId) {
    errors.push(messages.keyIdRequired);
  } else if (!KEY_ID_PATTERN.test(normalizedKeyId)) {
    errors.push(messages.keyIdInvalid);
  }
  if (!normalizedIssuerId) {
    errors.push(messages.issuerIdRequired);
  } else if (!ISSUER_ID_PATTERN.test(normalizedIssuerId)) {
    errors.push(messages.issuerIdInvalid);
  }

  return errors;
}

export function isAppleConfirmationReady({ matchReady, termsAccepted }) {
  return Boolean(matchReady) &&
    termsAccepted.length === 2 &&
    termsAccepted.every(Boolean);
}

export function getSelectedAppleShowId(candidates) {
  const selectedCandidate = Array.from(candidates || []).find((candidate) => candidate.checked);
  return selectedCandidate?.value || null;
}
